// extracted by mini-css-extract-plugin
var _1 = "TrophySparkle__sparkle--epFxV";
var _2 = "TrophySparkle__sparkleLarge--rY9VW";
var _3 = "TrophySparkle__sparkleMedium--qex0F";
var _4 = "TrophySparkle__sparkleMiddle--Ahk8h";
var _5 = "TrophySparkle__sparkleOuter--eE4cB";
var _6 = "TrophySparkle__sparkleSmall--Hc3pk";
var _7 = "TrophySparkle__trophy--wmC5Z";
export { _1 as "sparkle", _2 as "sparkleLarge", _3 as "sparkleMedium", _4 as "sparkleMiddle", _5 as "sparkleOuter", _6 as "sparkleSmall", _7 as "trophy" }
